import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './value-proposition-list.component.scss';
import * as Swiper from 'swiper/dist/js/swiper.js';
var ValuePropositionList = /** @class */ (function (_super) {
    tslib_1.__extends(ValuePropositionList, _super);
    function ValuePropositionList(element) {
        return _super.call(this, element) || this;
    }
    ValuePropositionList.prototype.init = function () {
        this.carouselSliderPagination = this.element.querySelector('.swiper-pagination');
        this.carouselSliderContainer = this.element.querySelector('.value-proposition-list__slider');
        this.carouselSlider = new Swiper(this.carouselSliderContainer, {
            slidesPerView: 3,
            centeredSlides: false,
            spaceBetween: 30,
            initialSlide: 0,
            breakpoints: {
                1024: {
                    initialSlide: 0,
                    slidesPerView: 2.5,
                    spaceBetween: 10,
                },
                767: {
                    initialSlide: 0,
                    slidesPerView: 2,
                    spaceBetween: 10,
                },
                580: {
                    initialSlide: 0,
                    slidesPerView: 1.2,
                    spaceBetween: 10,
                }
            },
            freeMode: false,
            pagination: {
                el: this.element.querySelector('.swiper-pagination'),
                type: 'bullets',
                clickable: true
            },
            navigation: {
                nextEl: this.element.querySelector('.swiper-button-next'),
                prevEl: this.element.querySelector('.swiper-button-prev')
            }
        });
    };
    ValuePropositionList.prototype.bindEvents = function () {
    };
    return ValuePropositionList;
}(Base));
export { ValuePropositionList };



//////////////////
// WEBPACK FOOTER
// ./components/value-proposition-list/value-proposition-list.component.ts
// module id = 762
// module chunks = 0